import { useEffect } from "react";

/**
 * Custom hook to handle modal effects:
 * - Hides the 'back to top' button
 * - Adds 'modal-open' class to body
 * - Disables body scroll (overflow: hidden)
 * 
 * @param {boolean} isOpen - Whether the modal is currently open
 */
export const useModalEffect = (isOpen) => {
  useEffect(() => {
    const backToTopBtn = document.getElementById('backToTopBtn');

    if (isOpen) {
      // Add modal-open class to body
      document.body.classList.add('modal-open');

      // Disable body scroll
      document.body.style.overflow = 'hidden';

      // Hide back to top button when modal is open
      if (backToTopBtn) {
        backToTopBtn.style.display = 'none';
      }
    }

    // Cleanup function
    return () => {
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');

      // Re-enable body scroll
      document.body.style.overflow = '';

      // Show back to top button when modal is closed
      if (backToTopBtn) {
        backToTopBtn.style.display = '';
      }
    };
  }, [isOpen]);
};
